import { a11yProps, sizeTab } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableClientesPymes from "../../shared/componente/table_cliente_pymes/TableClientesPymes";

export default function ClientesPymesPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Contratos Fisicos PYMES"}
      visibleReport={true}
      enableRedirect={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Pendiente Revisión'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableClientesPymes />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )

}